import "@fontsource/baloo-2/latin-700.css";
import "@fontsource/baloo-2/vietnamese-700.css";
import "@fontsource/baloo-2/latin-800.css";
import "@fontsource/baloo-2/vietnamese-800.css";
import "@fontsource/nunito/latin-400.css";
import "@fontsource/nunito/vietnamese-400.css";
import "@fontsource/nunito/latin-700.css";
import "@fontsource/nunito/vietnamese-700.css";
import "@fontsource/dancing-script/latin-700.css";
import "@fontsource/dancing-script/vietnamese-700.css";
import "./styles/base.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ApiError } from "./api/client.ts";
import { AppRouter } from "./app/router.tsx";
import { installSoundUnlock } from "./lib/sound.ts";

installSoundUnlock();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) =>
        !(error instanceof ApiError && error.status > 0 && error.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppRouter />
    </QueryClientProvider>
  </StrictMode>,
);
